import images from './images';

const services = [
    {
        number: '01',
        icon: 'code',
        title: 'web design',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque, ea.',
    },
    {
        number: '02',
        icon: 'mobile',
        title: 'responsive',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque, ea.',
    },
    {
        number: '03',
        icon: 'palette',
        title: 'custom design',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque, ea.',
    },
    {
        number: '04',
        icon: 'bullhorn',
        title: 'seo marketing',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque, ea.',
    },
    {
        number: '05',
        icon: 'envelope',
        title: 'email marketing',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque, ea.',
    },
    {
        number: '06',
        icon: 'headset',
        title: '24/7 service',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque, ea.',
    },
];

const pricing = [
    {
        id: 1,
        icon: 'paper-plane',
        plan: 'basic pane',
        price: '10',
        options: [
            '5 Projects',
            'maintenance',
            '5GB Storage',
            '1 domain ',
            '24/7 service',
        ],
    },
    {
        id: 2,
        icon: 'plane',
        plan: 'standard pane',
        price: '30',
        options: [
            '15 Projects',
            'maintenance',
            '15GB Storage',
            '15 domain ',
            '24/7 service',
        ],
    },
    {
        id: 3,
        icon: 'rocket',
        plan: 'premium pane',
        price: '50',
        options: [
            '25 Projects',
            'maintenance',
            '25GB Storage',
            '25 domain ',
            '24/7 service',
        ],
    },
];

const gallery = [
    {
        imgUrl: images.g1,
        title: 'Project 01',
        date: '01/09/2022',
    },
    {
        imgUrl: images.g2,
        title: 'Project 02',
        date: '01/09/2022',
    },
    {
        imgUrl: images.g3,
        title: 'Project 03',
        date: '01/09/2022',
    },
    {
        imgUrl: images.g4,
        title: 'Project 04',
        date: '01/09/2022',
    },
    {
        imgUrl: images.g5,
        title: 'Project 05',
        date: '01/09/2022',
    },
    {
        imgUrl: images.g6,
        title: 'Project 06',
        date: '01/09/2022',
    },
];

const reviews = [

    {
        userImg: images.user1,
        name: 'John Deo',
        review1: 'Debitis, consequuntur  Aperiam, illo quidem obcaecati et alias necessitatibus deleniti enim! Dolorum',
        review2: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, illo quidem obcaecati et alias necessitatibus deleniti enim! Dolorum, sapiente at.',
    },
    {
        userImg: images.user2,
        name: 'Melina',
        review1: 'Debitis, consequuntur  Aperiam, illo quidem obcaecati et alias necessitatibus deleniti enim! Dolorum',
        review2: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, illo quidem obcaecati et alias necessitatibus deleniti enim! Dolorum, sapiente at.',
    },
    {
        userImg: images.user3,
        name: ' Alex',
        review1: 'Debitis, consequuntur  Aperiam, illo quidem obcaecati et alias necessitatibus deleniti enim! Dolorum',
        review2: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, illo quidem obcaecati et alias necessitatibus deleniti enim! Dolorum, sapiente at.',
    },
];

const data = {
    services, pricing, gallery, reviews,
}

export default data;